var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library"
  }, /*#__PURE__*/React.createElement("path", {
    id: "library",
    "data-name": "regular clone",
    d: "M18.125,0H5.625A1.875,1.875,0,0,0,3.75,1.875V3.75H1.875A1.875,1.875,0,0,0,0,5.625v12.5A1.875,1.875,0,0,0,1.875,20h12.5a1.875,1.875,0,0,0,1.875-1.875V16.25h1.875A1.875,1.875,0,0,0,20,14.375V1.875A1.875,1.875,0,0,0,18.125,0ZM14.141,18.125H2.109a.234.234,0,0,1-.234-.234V5.859a.234.234,0,0,1,.234-.234H3.75v8.75A1.875,1.875,0,0,0,5.625,16.25h8.75v1.641A.234.234,0,0,1,14.141,18.125Zm3.75-3.75H5.859a.234.234,0,0,1-.234-.234V2.109a.234.234,0,0,1,.234-.234H17.891a.234.234,0,0,1,.234.234V14.141A.234.234,0,0,1,17.891,14.375Z",
    fill: "#3166b2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/Library.e6354c444fbddde40f01ded0a6036958.svg";
export { ForwardRef as ReactComponent };